// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var Carousel = "Carousel-module--Carousel--2_lkB";
export var Carousel__wrapper = "Carousel-module--Carousel__wrapper--1Z1Pa";
export var Carousel__promoSlot = "Carousel-module--Carousel__promoSlot--2CHDK";
export var Carousel__promoSlot__imageContainer = "Carousel-module--Carousel__promoSlot__imageContainer---8dUI";
export var Carousel__promoSlot__header = "Carousel-module--Carousel__promoSlot__header--2JxZL";
export var Carousel__promoSlot__title = "Carousel-module--Carousel__promoSlot__title--2UD2u";
export var Carousel__promoSlot__cta = "Carousel-module--Carousel__promoSlot__cta--2okvq";